import { createContext, useContext } from "react";

export interface FrameContextValue {
  /** True when a Frame.Footer slot is present; consumers may use this to alter spacing. */
  hasFooter: boolean;
  /** True when a Frame.BottomBar slot is present. */
  hasBottomBar: boolean;
  /** True once the scroller's sentinel has left the top edge. False on the server and on the
   *  first client paint, so scroll-dependent chrome never flashes before the observer reports. */
  isScrolled: boolean;
}

export const FrameContext = createContext<FrameContextValue | null>(null);

export function useFrameContext(): FrameContextValue {
  const ctx = useContext(FrameContext);
  if (!ctx) throw new Error("Frame slot components must be rendered inside <Frame>.");
  return ctx;
}

/** `isScrolled` for chrome that also renders outside a Frame (stories, standalone bars):
 *  reads as "at the top" instead of throwing. */
export function useFrameScrolled(): boolean {
  return useContext(FrameContext)?.isScrolled ?? false;
}
